'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$() {
  this.aIk = null;
  this.aIl = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$.prototype = $p;
$p.aA = (function() {
  if ((!this.aIl)) {
    this.aIk = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeString$$anon$1(this);
    this.aIl = true;
  }
  return this.aIk;
});
$p.ez = (function(input) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeNonEmptyString__validate__T__O(this, input);
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$, "app.data.data_point_types$package$Description$", ({
  FC: 1,
  B: 1,
  C: 1,
  J: 1,
  M: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$Description$ };
//# sourceMappingURL=app.data.data_point_types$package$-Description$.js.map
